import * as Yup from 'yup'

export const MerchantLookupTxSchemas = Yup.object().shape({
  field: Yup.string(),
  value: Yup.string(),
})
